import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useAPI } from '../hooks/useAPI';
import { contentAPI } from '../services/api';

const Pricing = () => {
  const { data: content, loading, error } = useAPI(contentAPI.getPricingContent, []);

  if (loading) {
    return (
      <>
        <Header variant="light" />
        <div className="flex items-center justify-center min-h-screen">
          <div className="text-center">
            <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-teal-900 mx-auto mb-4"></div>
            <p className="text-xl text-gray-700">Loading pricing...</p>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  if (error) {
    return (
      <>
        <Header variant="light" />
        <div className="flex items-center justify-center min-h-screen">
          <div className="text-center max-w-md">
            <h2 className="text-2xl font-bold text-red-600 mb-4">Error Loading Content</h2>
            <p className="text-gray-700">{error}</p>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <div>
        <section className="overflow-hidden">
          <Header variant="light" />
        </section>
      </div>

      <section className="relative py-12 lg:py-24 overflow-hidden">
        <img className="absolute top-0 right-0" src="/fauna-assets/pricing/waves-right-top.png" alt="" />
        <div className="container mx-auto px-4 relative">
        <div className="max-w-2xl mx-auto text-center mb-20">
            <h1 className="font-heading text-5xl sm:text-6xl tracking-xs mb-6">{content?.hero?.title || 'Pricing'}</h1>
            <p className="text-lg text-gray-700">
              {content?.hero?.subtitle || 'Our pricing plans are simple and designed to cater to households and companies of various sizes.'}
            </p>
          </div>
          <div className="flex flex-wrap -mx-4 mb-24">
            {content?.plans?.map((plan, index) => (
              <div key={index} className="w-full lg:w-1/3 px-4 mb-8 lg:mb-0">
                <div className={`relative pt-14 pb-8 px-8 rounded-2xl overflow-hidden ${plan.recommended ? 'bg-lime-500' : 'bg-orange-50'}`}>
                  {plan.recommended ? (
                    <div className="absolute top-0 left-0 w-full py-0.5 flex items-center justify-center bg-teal-900">
                      <span className="text-xs leading-7 text-white">Recommended</span>
                    </div>
                  ) : (
                    <div className="absolute top-0 left-0 h-1 w-full bg-lime-500"></div>
                  )}
                  <span className="block text-2xl font-medium mb-6">{plan.name}</span>
                  <div className="flex items-center mb-6">
                    <span className="text-6xl">{plan.price}</span>
                    {plan.priceUnit && <span className="ml-4 text-xl font-medium text-gray-700">{plan.priceUnit}</span>}
                  </div>
                  <p className="text-lg mb-8">{plan.description}</p>
                  <a className="inline-flex w-full group py-4 px-6 items-center justify-center text-lg font-medium text-black hover:text-white border border-teal-900 hover:bg-teal-900 rounded-full transition duration-200" href={plan.buttonLink || "#!"}>
                    <span className="mr-2">{plan.buttonText || 'Get started'}</span>
                    <span className="transform group-hover:translate-x-1 transition-transform duration-200">
                      <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.25 10H15.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                        <path d="M10.5 4.75L15.75 10L10.5 15.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                      </svg>
                    </span>
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Pricing;
